// src/components/feedback/FeedbackButton.tsx
// ヘッダー右側のフィードバックアイコン。パネル本体は FeedbackPanelHost（アプリ全体で常駐）。
import React from 'react';
import { t as uiText } from '../../i18n';
import { HeaderIconButton } from '../HeaderIconButton';
import { FEEDBACK_WIDGET_ATTR } from '../../features/feedback/capture';
import { toggleFeedbackPanel, useFeedbackPanelOpen } from '../../features/feedback/feedbackPanelStore';

type FeedbackButtonProps = {
  /** パネルを開くときに呼ぶ（スマホでサイドバーを閉じるなど） */
  onOpen?: () => void;
};

const FeedbackButton: React.FC<FeedbackButtonProps> = ({ onOpen }) => {
  const open = useFeedbackPanelOpen();
  return (
    // 画面を撮るときにこのボタンは写さない
    <div style={{ display: 'flex' }} {...{ [FEEDBACK_WIDGET_ATTR]: '' }}>
      <HeaderIconButton
        label={uiText("Feedback")}
        active={open}
        onClick={() => {
          if (!open) onOpen?.();
          toggleFeedbackPanel();
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </HeaderIconButton>
    </div>
  );
};

export default FeedbackButton;
